import cn from 'classnames';
import { DealHeader } from '@/finsight/ui/components/deals/DealListTable/components/DealHeader';
import { DealsTable } from '@/finsight/ui/components/deals/DealListTable/DealsTable';
import { ProfileTypes } from '@/finsight/application/actions/profile/constants';
import { withTileContext } from '@/finsight/ui/components/deals/DealTiles/withTileContext';

import styles from '@/finsight/ui/components/deals/DealTiles/IssueTile/issueTile.scss';

export interface IssueTileProps {
  profileType?: ProfileTypes,
  showDealStatusFilters?: boolean,
  titleToolbar?: React.ReactNode,
  title?: React.ReactNode,
  innerRef?: (el: HTMLElement) => void,
  showDealDetailsByDefault?: boolean,
  defaultExpandedRowIndexes?: number[],
  containerClassName?: string,
}

export const IssueTile = ({
  profileType,
  showDealStatusFilters,
  titleToolbar,
  defaultExpandedRowIndexes,
  showDealDetailsByDefault,
  title,
  innerRef,
  containerClassName,
}: IssueTileProps) => (
  <div className={ cn(styles.container, containerClassName) }>
    <DealHeader
      profileType={ profileType }
      showDealStatusFilters={ showDealStatusFilters }
      titleToolbar={ titleToolbar }
      title={ title }
      innerRef={ innerRef }
    >
      <DealsTable
        showDealDetailsByDefault={ showDealDetailsByDefault }
        defaultExpandedRowIndexes={ defaultExpandedRowIndexes }
      />
    </DealHeader>
  </div>
);

export default withTileContext(IssueTile);
